import { createFileRoute, notFound, useNavigate } from "@tanstack/react-router"
import { isPanelTab, type PanelTab } from "@/features/workplace/room-side-panel"
import { RoomView } from "@/features/workplace/room-view"

interface RoomSearch {
  tab?: Exclude<PanelTab, "tasks">
}

export const Route = createFileRoute("/_app/workplace/$roomId")({
  staticData: { titleKey: "workplace.room.title" },
  params: {
    parse: (p) => {
      const id = Number(p.roomId)
      if (!Number.isInteger(id) || id <= 0) throw notFound()
      return { roomId: String(id) }
    },
    stringify: (p) => p,
  },
  validateSearch: (s: Record<string, unknown>): RoomSearch => ({
    tab: isPanelTab(s.tab) && s.tab !== "tasks" ? s.tab : undefined,
  }),
  component: RoomPage,
})

function RoomPage() {
  const { roomId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <div className="h-full">
      <RoomView
        key={roomId}
        roomId={Number(roomId)}
        tab={search.tab ?? "tasks"}
        onTabChange={(tab) =>
          void navigate({ search: (s) => ({ ...s, tab: tab === "tasks" ? undefined : tab }), replace: true })
        }
      />
    </div>
  )
}
